module.exports = __webpack_public_path__ + "img/sankaku_20_red.d454b447.png";